import { useEffect, useState } from 'react';

import { apiFetch } from '../../../../utils';

import './index.css';

const BountiesPanelComponent = () => {
    const [bounties, setBounties] = useState([]);

    useEffect(() => {
        let isCancelled = false;

        const loadBounties = async () => {
            const response = await apiFetch('/user/bounties', 'POST', { page: 1, pageSize: 10 });
            if (isCancelled || !response || response.code !== 'success') return;

            const results = response?.data?.results;
            setBounties(Array.isArray(results) ? results : []);
        };

        loadBounties();

        return () => {
            isCancelled = true;
        };
    }, []);

    return (
        <div id='bounties-panel-container'>
            {bounties.map((row, index) => (
                <div className='bounties-panel-row' key={`${row.id}-${index}`}>
                    <p className='bounties-panel-name'>{row.bounty}</p>
                    <p className='bounties-panel-amount'>{Number(row.amount || 0).toLocaleString()}</p>
                </div>
            ))}

            {bounties.length === 0 && <p id='bounties-panel-empty'>No bounties posted yet.</p>}
        </div>
    );
};

export default BountiesPanelComponent;
